import { render, staticRenderFns } from "./ResourceRow.vue?vue&type=template&id=d4a46f0c&scoped=true"
import script from "./ResourceRow.vue?vue&type=script&lang=js"
export * from "./ResourceRow.vue?vue&type=script&lang=js"
import style0 from "./ResourceRow.vue?vue&type=style&index=0&id=d4a46f0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a46f0c",
  null
  
)

export default component.exports